var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColors(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.3 41L5 28.7C4.66667 28.3667 4.41667 28 4.25 27.6C4.08333 27.2 4 26.7833 4 26.35C4 25.9167 4.08333 25.5 4.25 25.1C4.41667 24.7 4.66667 24.3333 5 24L16.5 12.55L11.2 7.25L14.3 4L34.3 24C34.6333 24.3333 34.875 24.7 35.025 25.1C35.175 25.5 35.25 25.9167 35.25 26.35C35.25 26.7833 35.175 27.2 35.025 27.6C34.875 28 34.6333 28.3667 34.3 28.7L22 41C21.6667 41.3333 21.3 41.5833 20.9 41.75C20.5 41.9167 20.0833 42 19.65 42C19.2167 42 18.8 41.9167 18.4 41.75C18 41.5833 17.6333 41.3333 17.3 41ZM19.65 15.7L8.95 26.4H30.35L19.65 15.7ZM39.6 42C38.4 42 37.3833 41.575 36.55 40.725C35.7167 39.875 35.3 38.8333 35.3 37.6C35.3 36.7 35.525 35.85 35.975 35.05C36.425 34.25 36.9333 33.4667 37.5 32.7L39.6 30L41.8 32.7C42.3333 33.4667 42.8333 34.25 43.3 35.05C43.7667 35.85 44 36.7 44 37.6C44 38.8333 43.5667 39.875 42.7 40.725C41.8333 41.575 40.8 42 39.6 42Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.2941f581.svg";
export { ForwardRef as ReactComponent };